import { proxy } from 'valtio';

export const defaultState = false;

export const currentLODState: Record<string, boolean> = proxy({
  active: defaultState,
});
